import { Grid, Hidden } from '@material-ui/core';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { Button, Alert } from '@one-thd/sui-atomic-components';
import { pkAvailablePerks } from '../../../../constants/ProXtraPerks';
import { assets } from '../../../../images/AssetPaths';
import { fallbackImage } from '../../shared/commons';
import { clickCta } from '../../../../utils/analytics';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
var proXtraPerks = pkAvailablePerks;
var PerkOptionImage = function (props) {
    var altText = props.altText, src = props.src, height = props.height, width = props.width;
    return (React.createElement("img", { alt: altText || 'perk-img', src: src, height: height, width: width, onError: fallbackImage }));
};
export var YourOptionTab = function (_a) {
    var data = _a.data, stateData = _a.stateData, PerkInfo = _a.PerkInfo, handleChangeTab = _a.handleChangeTab;
    var tabColor;
    var idPerk = stateData.item.tierPerks[0].perkId === undefined
        ? stateData.item.tierId === data.item.tierId
        : stateData.item.tierPerks[0].perkId === data.item.tierPerks[0].perkId;
    var statusUnclaimed = stateData.item.tierPerks[0].perkStatus === 'UNCLAIMED';
    var earned = data.item.earned;
    if (idPerk && earned && statusUnclaimed) {
        tabColor = 'YourPerkOption__tabActive';
    }
    else if (idPerk && !earned) {
        tabColor = 'YourPerkOption__tabActive';
    }
    else {
        tabColor = 'YourPerkOption__tabOther';
    }
    var tabClass = TabCondition({ PerkInfo: PerkInfo, data: data, stateData: stateData });
    return (React.createElement(Grid, { item: true, container: true, lg: 12, xs: 12, sm: 12 },
        React.createElement("ul", { className: "tab-nav" },
            React.createElement(Grid, { className: "YourPerkOption__yearTab" }, data.item.yearEarned ? (React.createElement("p", null,
                data.item.yearEarned,
                " ")) : (React.createElement("p", null, "\u00A0"))),
            React.createElement(Grid, { className: tabColor },
                React.createElement("li", { role: "presentation", className: tabClass, onClick: function () { return handleChangeTab(data); } },
                    "$",
                    data.item.maxThresholdDisplay)))));
};
export var TabCondition = function (_a) {
    var stateData = _a.stateData, data = _a.data, PerkInfo = _a.PerkInfo;
    var tabs;
    var idPerk = stateData.item.tierPerks[0].perkId === undefined
        ? stateData.item.tierId === data.item.tierId
        : stateData.item.tierPerks[0].perkId === data.item.tierPerks[0].perkId;
    var tabEarned = data.item.earned;
    var statusunclaimed = stateData.item.tierPerks[0].perkStatus === 'UNCLAIMED';
    if (idPerk && tabEarned && statusunclaimed) {
        tabs = 'YourPerkOption__buttonEarnedInFocus YourPerkOption__activeTab ';
    }
    else if (idPerk && !tabEarned) {
        tabs =
            'YourPerkOption__buttonUnearnedInFocus YourPerkOption__activeTabCurrent';
    }
    else {
        tabs = TabSection({ data: data, PerkInfo: PerkInfo });
    }
    return tabs;
};
export var TabSection = function (_a) {
    var data = _a.data, PerkInfo = _a.PerkInfo;
    var tabSection;
    var tabEarned = data.item.earned;
    var currentTier = PerkInfo.currentTierId === data.item.tierId;
    var nextTier = PerkInfo.nextTierId === data.item.tierId;
    if (!tabEarned && currentTier) {
        tabSection = 'YourPerkOption__buttonCurrentDefault';
    }
    else if (!tabEarned && nextTier) {
        tabSection = 'YourPerkOption__buttonFutureInFocus';
    }
    else if (tabEarned) {
        tabSection = 'YourPerkOption__buttonEarnedDefault';
    }
    else {
        tabSection = '';
    }
    return tabSection;
};
export var RenderLeftGiftOption = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var giftCards = _a.giftCards, giftCardClicked = _a.giftCardClicked, handleClickOpen = _a.handleClickOpen, giftActive = _a.giftActive, currentData = _a.currentData, isMobile = _a.isMobile;
    var option = isMobile && ((_c = (_b = currentData === null || currentData === void 0 ? void 0 : currentData.item) === null || _b === void 0 ? void 0 : _b.tierPerks[0]) === null || _c === void 0 ? void 0 : _c.options.length) > 0
        ? (_e = (_d = currentData === null || currentData === void 0 ? void 0 : currentData.item) === null || _d === void 0 ? void 0 : _d.tierPerks[0]) === null || _e === void 0 ? void 0 : _e.options[0]
        : giftCards[0];
    var giftActiveData = giftActive[currentData.item.tierPerks[0].perkId];
    var giftCard = option ? option.amount : 0;
    var imageURL = option ? option.perkImageUrl : null;
    var title = option ? option.perkTitle : null;
    var hoverEarned = currentData.item.earned;
    var optionBorder;
    if (giftActiveData) {
        optionBorder = 'card-selected';
    }
    else if (hoverEarned) {
        optionBorder = 'card-enabled cardHover';
    }
    else {
        optionBorder = 'cardHover';
    }
    return (React.createElement(Grid, { className: "YourPerkOption__optionGiftBox", onClick: function () {
            clickCta('perks: selection drawer');
            if (currentData.item.tierPerks[0].perkStatus === 'UNCLAIMED')
                giftCardClicked(currentData.item.tierPerks[0].perkId);
        } },
        React.createElement(Grid, { className: optionBorder },
            optionBorder === 'card-selected' && (React.createElement("div", { className: "justify-content-end" },
                React.createElement("div", { className: "card-selected-before" },
                    React.createElement("img", { alt: "", src: "https://assets.thdstatic.com/images/alert-check-white.svg", height: "15px", width: "15px", className: "card-selected-before__checkMark" })))),
            React.createElement(Grid, { className: optionBorder === 'card-selected'
                    ? 'u__center selected-content'
                    : 'u__center' },
                React.createElement(PerkOptionImage, { loadingClasses: "lazy-image-options", altText: "", src: imageURL, height: "56px", width: "56px" }),
                ((_h = (_g = (_f = currentData === null || currentData === void 0 ? void 0 : currentData.item) === null || _f === void 0 ? void 0 : _f.tierPerks[0]) === null || _g === void 0 ? void 0 : _g.options[0]) === null || _h === void 0 ? void 0 : _h.activationType) !==
                    'CMS' && React.createElement(Grid, { className: "perkOptionAmount" },
                    "$",
                    giftCard),
                React.createElement(Grid, { className: "perkOptionTitle " },
                    React.createElement("span", null, title === null || title === void 0 ? void 0 : title.substring(0, 24)))),
            React.createElement(Grid, { className: "u__center perkOptionDetailsLink" },
                React.createElement("button", { type: "button", onClick: function () { return handleClickOpen(1, true, giftCard, title); } },
                    React.createElement("u", null, "Details"))))));
};
export var RenderLeftRedeemedGiftOption = function (_a) {
    var handleClickOpen = _a.handleClickOpen, currentData = _a.currentData;
    var getDisplayAmount = useDisplayAmount();
    var amount = currentData.item.tierPerks[0].amount;
    var title = currentData.item.tierPerks[0].perkTitle;
    var imageURL = currentData.item.tierPerks[0].perkImageUrl;
    return (React.createElement(Grid, { className: "YourPerkOption__optionBox" },
        React.createElement(Grid, { className: "YourPerkOption__productInActive" },
            React.createElement("div", { className: "justify-content-end" },
                React.createElement("div", { className: "card-selected-before" },
                    React.createElement("img", { alt: "", src: "https://assets.thdstatic.com/images/alert-check-white.svg", height: "15px", width: "15px", className: "card-selected-before__checkMark" }))),
            React.createElement(Grid, { item: true, className: "YourPerkOption__optionInsideBox u__center" },
                React.createElement(Grid, { item: true, className: "" },
                    React.createElement(PerkOptionImage, { loadingClasses: "lazy-image-options", altText: "", src: imageURL, height: "56px", width: "56px" }),
                    React.createElement(Grid, { item: true, className: "YourPerkOption__optionAmount " }, getDisplayAmount(currentData.item.tierPerks[0])),
                    React.createElement(Grid, { item: true, className: "YourPerkOption__optionType" }, title === null || title === void 0 ? void 0 : title.substring(0, 24))),
                React.createElement("span", { role: "presentation", className: "details", onClick: function () { return handleClickOpen(1, true, amount, title); } }, "Details")))));
};
export var RenderRightRentalOption = function (_a) {
    var _b, _c, _d, _e;
    var rentalActive = _a.rentalActive, currentData = _a.currentData, perkLibrary = _a.perkLibrary, freeRentalClicked = _a.freeRentalClicked, handleClickOpen = _a.handleClickOpen, isMobile = _a.isMobile;
    var getDisplayAmount = useDisplayAmount();
    var option = isMobile && ((_c = (_b = currentData === null || currentData === void 0 ? void 0 : currentData.item) === null || _b === void 0 ? void 0 : _b.tierPerks[0]) === null || _c === void 0 ? void 0 : _c.options.length) > 0
        ? (_e = (_d = currentData === null || currentData === void 0 ? void 0 : currentData.item) === null || _d === void 0 ? void 0 : _d.tierPerks[0]) === null || _e === void 0 ? void 0 : _e.options[1]
        : perkLibrary[0];
    var rentalTool = rentalActive[currentData.item.tierPerks[0].perkId];
    var redeemedStatus = currentData.item.tierPerks[0].perkStatus === 'REDEEMED';
    var rentalAmount = option ? option.amount : 0;
    var imageURL = option ? option.perkImageUrl : null;
    var title = option ? option.perkTitle : null;
    var hoverEarned = currentData.item.earned;
    var optionRightBorder;
    if (rentalTool) {
        optionRightBorder = 'card-selected';
    }
    else if (hoverEarned) {
        optionRightBorder = 'card-enabled cardHover';
    }
    else if (redeemedStatus) {
        optionRightBorder = 'card-Redeemedselected';
    }
    else {
        optionRightBorder = 'cardHover';
    }
    return (React.createElement(Grid, { className: "YourPerkOption__optionRentalBox", onClick: function () {
            clickCta('perks: selection drawer');
            if (currentData.item.tierPerks[0].perkStatus === 'UNCLAIMED')
                freeRentalClicked(currentData.item.tierPerks[0].perkId);
        } },
        React.createElement(Grid, { className: optionRightBorder },
            optionRightBorder === 'card-selected' && (React.createElement("div", { className: "justify-content-end" },
                React.createElement("div", { className: "card-selected-before" },
                    React.createElement("img", { alt: "", src: "https://assets.thdstatic.com/images/alert-check-white.svg", height: "15px", width: "15px", className: "card-selected-before__checkMark" })))),
            React.createElement(Grid, { className: optionRightBorder === 'card-selected'
                    ? 'u__center selected-content'
                    : 'u__center' },
                React.createElement(PerkOptionImage, { loadingClasses: "lazy-image-options", altText: "", src: imageURL, height: "56px", width: "56px" }),
                React.createElement(Grid, { className: "perkOptionAmount" }, getDisplayAmount(currentData.item.tierPerks[0])),
                React.createElement(Grid, { className: "perkOptionTitle " },
                    React.createElement("span", null,
                        " ", title === null || title === void 0 ? void 0 :
                        title.substring(0, 24)))),
            React.createElement(Grid, { className: "u__center perkOptionDetailsLink" },
                React.createElement("button", { type: "button", onClick: function () { return handleClickOpen(2, true, rentalAmount, title); } },
                    React.createElement("u", null, "Details"))))));
};
export var RenderRightRedeemedOption = function (_a) {
    var currentData = _a.currentData, freeRentalClicked = _a.freeRentalClicked, handleClickOpen = _a.handleClickOpen;
    var getDisplayAmount = useDisplayAmount();
    var amount = currentData.item.tierPerks[0].amount;
    var title = currentData.item.tierPerks[0].perkTitle;
    var option = currentData.item.tierPerks[0].isGiftCard ? 1 : 2;
    return (React.createElement(Grid, { className: "YourPerkOption__optionBox" },
        React.createElement(Grid, { className: "YourPerkOption__productInActive" },
            React.createElement("div", { className: "justify-content-end" },
                React.createElement("div", { className: "card-selected-inactive" },
                    React.createElement("img", { alt: "", src: "https://assets.thdstatic.com/images/alert-check-white.svg", height: "15px", width: "15px", className: "card-selected-before__checkMark" }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 12, className: "YourPerkOption__optionInsideBox " },
                React.createElement(Grid, { item: true, onClick: function () {
                        return currentData.item.tierPerks[0].perkStatus === 'UNCLAIMED'
                            ? freeRentalClicked(currentData.item.tierPerks[0].perkId)
                            : '';
                    } },
                    React.createElement(Grid, null,
                        React.createElement(Grid, null,
                            React.createElement(PerkOptionImage, { loadingClasses: "lazy-image-options", altText: "", src: currentData.item.tierPerks[0].perkImageUrl, height: "56px", width: "56px" })),
                        React.createElement(Grid, { item: true, className: "YourPerkOption__optionAmount " }, getDisplayAmount(currentData.item.tierPerks[0])),
                        React.createElement(Grid, { item: true, className: "YourPerkOption__optionType " }, title === null || title === void 0 ? void 0 : title.substring(0, 24)))),
                React.createElement("span", { role: "presentation", className: "details", onClick: function () { return handleClickOpen(option, true, amount, title); } }, "Details")))));
};
export var ModelGiftOptionCard = function (_a) {
    var optionDollar = _a.optionDollar, currentData = _a.currentData, selectedAmount = _a.selectedAmount;
    var getDisplayAmount = useDisplayAmount();
    var title = optionDollar[0]
        ? optionDollar[0].perkTitle
        : currentData.item.tierPerks[0].perkTitle;
    var image = optionDollar[0]
        ? optionDollar[0].perkImageUrl
        : currentData.item.tierPerks[0].perkImageUrl;
    return (React.createElement(Grid, { className: "sui-flex sui-flex-row sui-justify-start sui-align-center sui-py-2" },
        React.createElement(Grid, { item: true, xs: 12, sm: 12, className: " sui-flex sui-flex-col sui-justify-center sui-align-center sui-ml-2" },
            React.createElement(PerkOptionImage, { altText: "", src: image, height: "56px", width: "56px" })),
        ' ',
        React.createElement(Grid, { item: true, className: "YourPerkOption__optionAmount sui-flex sui-flex-col sui-justify-center sui-align-center" },
            getDisplayAmount(currentData.item.tierPerks[0]), title === null || title === void 0 ? void 0 :
            title.substring(0, 24))));
};
export var ModelRentalOptionCard = function (_a) {
    var optionPerkLibrary = _a.optionPerkLibrary, isMobile = _a.isMobile, rentalActive = _a.rentalActive, currentData = _a.currentData, selectedAmount = _a.selectedAmount;
    var getDisplayAmount = useDisplayAmount();
    var rentalToolData = rentalActive[currentData.item.tierPerks[0].perkId];
    var image = optionPerkLibrary[0]
        ? optionPerkLibrary[0].perkImageUrl
        : currentData.item.tierPerks[0].perkImageUrl;
    var title = optionPerkLibrary[0]
        ? optionPerkLibrary[0].perkTitle
        : currentData.item.tierPerks[0].perkTitle;
    var rentalActiveClass = '';
    if (rentalToolData)
        rentalActiveClass = 'activeTriangle triangleModel1';
    if (isMobile)
        rentalActiveClass = 'activeTriangle triangleModel';
    return (React.createElement(Grid, { className: rentalToolData
            ? ' YourPerkOption__productModelActive'
            : ' productModelInActive' },
        React.createElement(Grid, { className: rentalActiveClass }),
        React.createElement(Grid, { item: true, xs: 12, sm: 12, className: "YourPerkOption__optionInsideBox " },
            React.createElement(Grid, null,
                React.createElement(PerkOptionImage, { altText: "", src: image, height: "72px", width: "72px" })),
            React.createElement(Grid, { item: true, className: "YourPerkOption__optionAmount " }, getDisplayAmount(currentData.item.tierPerks[0])),
            React.createElement(Grid, { item: true, className: "YourPerkOption__optionType " }, title === null || title === void 0 ? void 0 : title.substring(0, 24)))));
};
export var ModelButton = function (_a) {
    var data = _a.data, selectedIsDetailsClick = _a.selectedIsDetailsClick, handleClose = _a.handleClose, selectedOption = _a.selectedOption, confirmPerkActivate = _a.confirmPerkActivate;
    return (React.createElement(Grid, { item: true, xs: 12 }, data.item.tierPerks[0].perkStatus !== 'UNCLAIMED' &&
        selectedIsDetailsClick ? (React.createElement(Hidden, { smDown: true },
        React.createElement(Grid, { item: true, className: "YourPerkOption__buttonModelCloseRow" },
            React.createElement(Button, { type: "button", className: "btn YourPerkOption__buttonModelConfirmPerkActive ", onClick: handleClose }, "Close")))) : (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Hidden, { smDown: true },
            React.createElement("div", { className: "YourPerkOption__buttonModelConfirmRow" },
                React.createElement("div", null,
                    React.createElement(Button, { type: "button", className: "YourPerkOption__modelDifferntPerkButtonPerk ", onClick: handleClose }, "Choose a Different Perk")),
                React.createElement("div", null,
                    React.createElement(Button, { type: "button", className: "btn YourPerkOption__buttonModelConfirmPerkActive ", onClick: function () { return confirmPerkActivate(selectedOption); } }, "Confirm")))),
        React.createElement(Hidden, { mdUp: true },
            React.createElement("div", null,
                React.createElement(Button, { type: "button", className: "btn buttonMobileModelConfirmPerk", onClick: function () { return confirmPerkActivate(selectedOption); } }, "Confirm")),
            React.createElement("div", { className: "YourPerkOption__mobileButtonCentered" },
                React.createElement(Button, { type: "button", className: "YourPerkOption__modelMobileDifferntPerkButtonPerk topMargin", onClick: handleClose }, "Choose a Different Perk")))))));
};
var ModelOptionError = function (_a) {
    var hasError = _a.hasError;
    return (React.createElement(Grid, { item: true, lg: 12, xs: 12, sm: 12 }, hasError && React.createElement(ModelBodyContentErrorOccured, null)));
};
var ModelOptionLeft = function (_a) {
    var optionDollar = _a.optionDollar, currentData = _a.currentData, selectedAmount = _a.selectedAmount, selectedIsDetailsClick = _a.selectedIsDetailsClick, hasError = _a.hasError, isEarned = _a.isEarned;
    var getDisplayAmount = useDisplayAmount();
    var title = optionDollar[0]
        ? optionDollar[0].perkTitle
        : currentData.item.tierPerks[0].perkTitle;
    var perkDescription = optionDollar[0]
        ? optionDollar[0].perkDescription
        : currentData.item.tierPerks[0].perkDescription;
    var image = optionDollar[0]
        ? optionDollar[0].perkImageUrl
        : currentData.item.tierPerks[0].perkImageUrl;
    var infoIcon = assets.icons.info;
    return (React.createElement(Grid, { item: true, lg: 12, xs: 12, sm: 12 },
        React.createElement(Grid, { className: "YourPerkOption__modelAmountTitle" },
            React.createElement(PerkOptionImage, { altText: "", src: image, height: "56px", width: "56px" }),
            getDisplayAmount(currentData.item.tierPerks[0], optionDollar[0]), title === null || title === void 0 ? void 0 :
            title.substring(0, 24)),
        !selectedIsDetailsClick && isEarned && (React.createElement(Grid, { className: "YourPerkOption__modelBold" },
            React.createElement("div", { className: "info-container" },
                React.createElement("div", { className: "info-corner" }),
                React.createElement("div", { className: "alert-box" },
                    React.createElement("div", { className: "info-icon" },
                        React.createElement(PerkOptionImage, { src: infoIcon, altText: "info", width: "14px", height: "14px" })),
                    React.createElement("div", { className: "error-label" },
                        React.createElement("p", null, "All Pro Xtra Perks are final after confirmation")))))),
        React.createElement(Grid, { item: true, className: "YourPerkOption__modelDescription" },
            React.createElement(Grid, { className: "YourPerkOption__modelPerkParagraph" },
                React.createElement(ReactMarkdown, { source: perkDescription, renderers: {
                        link: function (props) { return (React.createElement("a", { href: props.href, rel: "noreferrer", target: "_blank" }, props.children)); },
                    } }))),
        React.createElement(ModelOptionError, { hasError: hasError })));
};
var ModelOptionLibrary = function (_a) {
    var optionPerkLibrary = _a.optionPerkLibrary, currentData = _a.currentData, selectedAmount = _a.selectedAmount, selectedIsDetailsClick = _a.selectedIsDetailsClick, isEarned = _a.isEarned, hasError = _a.hasError;
    var getDisplayAmount = useDisplayAmount();
    var title = optionPerkLibrary[0]
        ? optionPerkLibrary[0].perkTitle
        : currentData.item.tierPerks[0].perkTitle;
    var perkDescription = optionPerkLibrary[0]
        ? optionPerkLibrary[0].perkDescription
        : currentData.item.tierPerks[0].perkDescription;
    var image = optionPerkLibrary[0]
        ? optionPerkLibrary[0].perkImageUrl
        : currentData.item.tierPerks[0].perkImageUrl;
    var infoIcon = assets.icons.info;
    return (React.createElement(Grid, { item: true, lg: 12, xs: 12, sm: 12 },
        React.createElement(Grid, { className: "YourPerkOption__modelAmountTitle" },
            React.createElement(PerkOptionImage, { altText: "", src: image, height: "56px", width: "56px" }),
            getDisplayAmount(currentData.item.tierPerks[0], optionPerkLibrary[0]), title === null || title === void 0 ? void 0 :
            title.substring(0, 24)),
        !selectedIsDetailsClick && isEarned && (React.createElement(Grid, { className: "YourPerkOption__modelBold" },
            React.createElement("div", { className: "info-container" },
                React.createElement("div", { className: "info-corner" }),
                React.createElement("div", { className: "alert-box" },
                    React.createElement("div", { className: "info-icon" },
                        React.createElement(PerkOptionImage, { src: infoIcon, altText: "info", width: "14px", height: "14px" })),
                    React.createElement("div", { className: "error-label" },
                        React.createElement("p", null, "All Pro Xtra Perks are final after confirmation")))))),
        React.createElement(Grid, { item: true, className: "YourPerkOption__modelDescription" },
            React.createElement(Grid, { className: "YourPerkOption__modelPerkParagraph" },
                React.createElement(ReactMarkdown
                // eslint-disable-next-line react/no-children-prop
                , { 
                    // eslint-disable-next-line react/no-children-prop
                    children: perkDescription, renderers: {
                        link: function (props) { return (React.createElement("a", { href: props.href, rel: "noreferrer", target: "_blank" }, props.children)); },
                    } }))),
        React.createElement(ModelOptionError, { hasError: hasError })));
};
export var ModelOption = function (_a) {
    var option = _a.option, currentData = _a.currentData, giftActive = _a.giftActive, selectedAmount = _a.selectedAmount, rentalActive = _a.rentalActive, optionDollar = _a.optionDollar, optionPerkLibrary = _a.optionPerkLibrary;
    switch (option) {
        case 1:
            return (React.createElement(ModelGiftOptionCard, { currentData: currentData, giftActive: giftActive, selectedAmount: selectedAmount, optionDollar: optionDollar }));
        case 2:
            return (React.createElement(ModelRentalOptionCard, { currentData: currentData, rentalActive: rentalActive, selectedAmount: selectedAmount, optionPerkLibrary: optionPerkLibrary }));
        default:
            return null;
    }
};
export var ModelOptionBodyTitle = function (_a) {
    var option = _a.option, currentData = _a.currentData, selectedAmount = _a.selectedAmount, selectedIsDetailsClick = _a.selectedIsDetailsClick, hasError = _a.hasError, optionDollar = _a.optionDollar, optionPerkLibrary = _a.optionPerkLibrary;
    var earned = currentData.item.earned;
    switch (option) {
        case 1:
            return (React.createElement(ModelOptionLeft, { optionDollar: optionDollar, currentData: currentData, selectedAmount: selectedAmount, selectedIsDetailsClick: selectedIsDetailsClick, hasError: hasError, option: option, isEarned: earned }));
        case 2:
            return (React.createElement(ModelOptionLibrary, { optionPerkLibrary: optionPerkLibrary, currentData: currentData, selectedAmount: selectedAmount, selectedIsDetailsClick: selectedIsDetailsClick, hasError: hasError, option: option, isEarned: earned }));
        default:
            return null;
    }
};
var ModelBodyContentErrorOccured = function () { return (React.createElement(Grid, { item: true, container: true, lg: 12, xs: 12, sm: 12, className: "YourPerkOption__errorSquareText" },
    React.createElement("div", { className: "error-container" },
        React.createElement("div", { className: "error-corner" }),
        React.createElement("div", { className: "alert-box" },
            React.createElement("div", { className: "error-icon" },
                React.createElement(PerkOptionImage, { src: assets.icons.error, altText: "squareerror", width: "16px", height: "16px" })),
            React.createElement("div", { className: "error-label" },
                React.createElement("p", null, "\u00A0\u00A0An error has occured. Please try again.")))))); };
export var GetUnclaimedCount = function (PerkInfo) {
    var tiers = PerkInfo.program.tiers;
    var unclaimedPerkCount = 0;
    for (var i = 0; i < tiers.length; i += 1) {
        var tier = tiers[i];
        if (tier.earned && tier.tierPerks[0].perkStatus === 'UNCLAIMED') {
            unclaimedPerkCount += 1;
        }
    }
    for (var i = 0; i < PerkInfo.previousYearPerks.length; i += 1) {
        var tier = PerkInfo.previousYearPerks[i];
        if (tier.perkStatus === 'UNCLAIMED') {
            unclaimedPerkCount += 1;
        }
    }
    return unclaimedPerkCount;
};
export var RenderYourPerkOptionsSubTitle = function (_a) {
    var PerkInfo = _a.PerkInfo;
    var count = GetUnclaimedCount(PerkInfo);
    return (React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 }, count === 0 ? (React.createElement(Grid, { className: "YourPerkOption__unclaimedCountStatus" }, proXtraPerks.youNoUnclaimedPerks)) : (React.createElement(Grid, { className: "YourPerkOption__unclaimedCountStatus" },
        proXtraPerks.youHave,
        " ",
        React.createElement("b", null,
            " ",
            count,
            " "),
        proXtraPerks.unclaimedPerks))));
};
export var ClaimBefore = function (_a) {
    var currentData = _a.currentData;
    var _b = currentData.item, currentTier = _b.currentTier, earned = _b.earned;
    var claim = currentData.item.tierPerks[0].perkStatus !== 'UNCLAIMED';
    var futureTier = !currentTier && !earned;
    var warningIcon = assets.icons.warning;
    if (futureTier) {
        return (React.createElement(Grid, null,
            React.createElement(Grid, { className: "claimBefore" },
                React.createElement(Grid, null, proXtraPerks.perkText.perkrevealed),
                React.createElement(Grid, null, proXtraPerks.perkText.beginmileston))));
    }
    return (React.createElement(Grid, null, earned && !claim && (React.createElement(Grid, { className: "claimBefore" },
        React.createElement("div", { className: "warning-container" },
            React.createElement("div", { className: "warning-corner" }),
            React.createElement("div", { className: "alert-box" },
                React.createElement("div", { className: "warning-icon" },
                    React.createElement(PerkOptionImage, { src: warningIcon, altText: "warning", width: "14px", height: "14px" })),
                React.createElement("div", { className: "error-label" },
                    proXtraPerks.choosePerkBy,
                    ' ',
                    currentData.item.tierPerks[0].expirationTime)))))));
};
export var OptionClaimedRight = function (_a) {
    var currentData = _a.currentData;
    return (React.createElement(Grid, { container: true, className: "YourPerkOption__claimedItemBox" },
        React.createElement(Grid, { className: "YourPerkOption__claimedLabel" },
            React.createElement(Grid, null, "Claimed :"),
            React.createElement(Grid, null, currentData.item.tierPerks[0].activationTime ||
                new Date().toLocaleDateString())),
        currentData.item.tierPerks[0].daysLeft <= 14 && (React.createElement(Grid, { item: true, xs: 12, className: "YourPerkOption__claiAfter" },
            React.createElement(Alert, { status: "warning" },
                currentData.item.tierPerks[0].daysLeft,
                "\u00A0",
                proXtraPerks.dayLeftPerk)))));
};
export var OptionFutureOption = function () {
    return (React.createElement(Grid, { className: "YourPerkOption__optionBox" },
        React.createElement(Grid, { className: "YourPerkOption__productInActive" },
            React.createElement(Grid, { className: "YourPerkOption__futureCard" },
                React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/loyaltyBenefits/pro-xtra-perk-icon.svg", alt: "proxtra perk icon", className: "YourPerkOption__futureLogo", height: "16px", width: "16px" }),
                React.createElement(Grid, { className: "YourPerkOption__futureBlankLink" }),
                React.createElement(Grid, { className: "YourPerkOption__futureBlankLink1" }),
                React.createElement(Grid, { className: "YourPerkOption__futureBlankLine" })))));
};
export var FuturePerkStatus = function () { return (React.createElement(Grid, { item: true, className: "YourPerkOption__perkTitleBox" },
    React.createElement(Grid, { className: "YourPerkOption__perkTitleHeading" }, "Your Next Perk"),
    React.createElement(Grid, { className: "YourPerkOption__perkTitleSubHeading" }, "Find Your Future Perk Options Here"))); };
export var AfterSpendingMaxStatus = function (_a) {
    var currentData = _a.currentData;
    return (React.createElement(Grid, { item: true, className: "YourPerkOption__perkTitleBox" },
        React.createElement(Grid, { className: "YourPerkOption__perkTitleHeading" }, "Your Perk Options"),
        React.createElement(Grid, { className: "YourPerkOption__perkTitleSubHeading" },
            "After Spending ",
            React.createElement("b", null,
                "$",
                currentData.item.maxThresholdDisplay))));
};
export var YouSelectedStatus = function (_a) {
    var currentData = _a.currentData;
    return (React.createElement(Grid, { item: true, className: "YourPerkOption__perkTitleBox" },
        React.createElement(Grid, { className: "YourPerkOption__perkTitleHeading" },
            "At $",
            currentData.item.maxThresholdDisplay,
            " You Selected")));
};
export var ReachedTitle = function (_a) {
    var currentData = _a.currentData;
    var currentDate = new Date();
    var date = new Date(currentData.item.tierPerks[0].creationTime);
    var diff = (currentDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
    var newIconStatus = currentData.item.tierPerks[0].perkStatus === 'UNCLAIMED' &&
        currentData.item.tierPerks[0].earned &&
        diff <= 14;
    return (React.createElement(Grid, { item: true, md: 12, lg: 12, xs: 12, sm: 12, className: "YourPerkOption__perkTitleBox" },
        React.createElement(Grid, { className: "YourPerkOption__perkTitleHeading" },
            newIconStatus && (
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            React.createElement("span", { className: "sui-mr-1 sui-mt-[-1px] sui-inline-block" },
                React.createElement(PerkOptionImage, { src: "https://assets.thdstatic.com/images/v1/loyaltyBenefits/notif-perk-new.svg", altText: "new icon", loadingClasses: "new-icon-load", classes: "new-icon", height: "19px", width: "45px" }))),
            proXtraPerks.chooseYourPerk),
        React.createElement(Grid, { className: "YourPerkOption__perkTitleSubHeading" },
            proXtraPerks.youReached,
            " ",
            React.createElement("b", null,
                "$",
                currentData.item.maxThresholdDisplay),
            ' ',
            proXtraPerks.inSpend)));
};
export var ReachedSpendMobileTitle = function (_a) {
    var currentData = _a.currentData, PerkInfo = _a.PerkInfo;
    var titleclaimed = currentData.item.tierPerks[0].perkStatus !== 'UNCLAIMED';
    var titleUnclaimed = currentData.item.tierPerks[0].perkStatus === 'UNCLAIMED';
    var statusRedeemed = currentData.item.tierPerks[0].perkStatus === 'REDEEMED';
    var statusActive = currentData.item.tierPerks[0].perkStatus === 'ACTIVE' ||
        currentData.item.tierPerks[0].perkStatus === 'INACTIVE';
    var nextTier = PerkInfo.nextTierId === currentData.item.tierId;
    var currentTier = PerkInfo.currentTierId === currentData.item.tierId;
    var zeroCurrentMin = PerkInfo.currentYearSpend === 0 && currentData.item.minThreshold === 0;
    var titleEarned = currentData.item.earned;
    if (zeroCurrentMin && titleclaimed) {
        return React.createElement(AfterSpendingMaxStatus, { currentData: currentData });
    }
    if (statusActive) {
        return React.createElement(YouSelectedStatus, { currentData: currentData });
    }
    if (!titleEarned && nextTier) {
        return React.createElement(FuturePerkStatus, null);
    }
    if (statusActive || (titleEarned && titleUnclaimed)) {
        return React.createElement(ReachedTitle, { currentData: currentData });
    }
    if (!titleEarned && currentTier) {
        return React.createElement(AfterSpendingMaxStatus, { currentData: currentData });
    }
    if (statusRedeemed) {
        return React.createElement(YouSelectedStatus, { currentData: currentData });
    }
    return React.createElement(React.Fragment, null);
};
